// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"1388f2dc","435":"dd7d2654","552":"2608c65b","817":"081e0f41","959":"bca1576e","962":"308d6507"}[chunkId] + ".chunk.js";
};